import type { FunctionComponent } from 'react';
import classNames from 'classnames';
import LazyLoad from 'react-lazyload';
import { StarRatingButton } from '@fff-web/fff-ratings-and-reviews';
import * as styles from './styles.module.scss';

type ProductItemProps = {
  productId: number;
  imageUrl: string;
  productBrand: string | null;
  productName: string;
  rating: number;
  onClick: (productId: number, value: number) => void;
};

const ProductItem: FunctionComponent<ProductItemProps> = ({
  productId,
  imageUrl,
  productBrand = null,
  productName,
  rating,
  onClick,
}) => {
  const handleOnClick = (value: number) => onClick(productId, value);

  return (
    <div data-testid="product-item">
      <LazyLoad className={classNames(styles.container, { [styles.disabled]: rating > 0 })} once>
        <button type="button" onClick={() => handleOnClick(0)}>
          <img src={imageUrl} alt={productName} />
        </button>
        <div className={styles.details}>
          <p className={styles.brand}>{productBrand}</p>
          <p className={styles.name}>{productName}</p>
          <div className={styles.ratingContainer}>
            <StarRatingButton
              name={productId}
              size={24}
              containerWidth={184}
              defaultValue={rating}
              onClick={handleOnClick}
            />
          </div>
        </div>
      </LazyLoad>
    </div>
  );
};

export default ProductItem;
